import { render } from "./popupCharge_Wallet.vue?vue&type=template&id=12030f00"
import script from "./popupCharge_Wallet.vue?vue&type=script&lang=js"
export * from "./popupCharge_Wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__